
// imported in base router.ts
export default
	[
		{
			path: "/websiteconfiguration/:id/auth/",
			name: "authconfiguration",
			component: () => import("@/Views/Domain/Settings/AuthConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "External Authorization configuration", page: "website" }
		},
		{
			path: "/classicconfiguration/:id/auth/",
			name: "classicconfiguration",
			component: () => import("@/Views/Domain/Settings/ClassicConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Classic configuration", page: "website" }
		},
		{
			path: "/domainsettings/:id/",
			name: "domainsettings",
			component: () => import("@/Views/Domain/Settings/WebsiteSettings.vue"),
			props: true,
			children: [
			],
			meta: { name: "Domain Settings", page: "website" }
		}
	];
